export default __webpack_public_path__ + "static/media/play-icon.c7bb98b5.svg";